import axios from "axios";
import interceptors from "@/shared/api/interceptors";

const apiClient4 = axios.create({
  baseURL: window.__CONFIG__.VUE_APP_BASE_DOMAIN + "/we",
  withCredentials: true,
});

interceptors(apiClient4);

export default apiClient4;
